import * as React from 'react';

export default function Pin({...rest}) {
  return (
    <svg
      width="14"
      height="22"
      viewBox="0 0 14 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C11 0 14 3 14 7.1C14 10.2 12.9 13.6 11.1 16.9C9.6 19.7 7.9 22 7 22C6.1 22 4.4 19.8 2.9 16.9C1.1 13.6 0 10.2 0 7.1C0 3 3 0 7 0ZM7 1.3C3.7 1.3 1.3 3.7 1.3 7C1.3 9.7 2.2 12.9 4 16.2C5.4 18.9 6.5 20.1 7 20.5C7.5 20.1 8.5 18.9 10 16.2C11.8 12.9 12.7 9.7 12.7 7C12.7 3.7 10.3 1.3 7 1.3ZM10 7C10 5.3 8.7 4 7 4C5.3 4 4 5.3 4 7C4 8.7 5.3 10 7 10C8.7 10 10 8.7 10 7Z"
        fill="#001E50"
      />
    </svg>
  );
}
